import { useCallback, useEffect, useState } from 'react';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ResultHelper } from '~src/httpClient/utils/ResultHelper';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { GetTrialsRequest, IGetTrialsResult } from '~src/siteManagement/serverApi/requests/trial/GetTrialsRequest';
import { ISiteTrial } from '~src/siteManagement/serverApi/types/ISiteTrial';

export const useGetSiteTrials = (): [ISiteTrial[] | undefined, () => Promise<void>] => {
  const [siteTrials, setSiteTrials] = useState<ISiteTrial[] | undefined>(undefined);

  const getSiteTrials = useCallback(async () => {
    if (!FeatureFlags.tabAITryItEnabled) {
      return;
    }

    const result = await WebHttpClient.sendRequest(new GetTrialsRequest()) as IResult & IGetTrialsResult;
    if (ResultHelper.hasErrors(result)) {
      const err = result.errors![0];
      throw new Error(err.message ?? String(err.code));
    }
    setSiteTrials(result.trials ?? []);
  }, []);

  useEffect(() => {
    void getSiteTrials();
  }, [getSiteTrials]);

  return [siteTrials, getSiteTrials];
};
